// src/components/Accordion.js
import React, { useState, useContext } from "react";
import ThemeContext from "../../context/ThemeContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faMinus } from "@fortawesome/free-solid-svg-icons";
import "./Accordion.css";
const Accordion = ({ children }) => {
  const [isActive, setIsActive] = useState(false);
  const { theme } = useContext(ThemeContext);
  const handleToggle = () => {
    setIsActive(!isActive);
  };
  const toggleAccordion = () => setIsActive(!isActive);

  return (
    <div>
      <button className={`accordion ${theme}`} onClick={toggleAccordion}>
        <button
          onClick={handleToggle}
          className={`icon-button ${theme}`}
          aria-label={isActive ? "Collapse" : "Expand"}
        >
          <FontAwesomeIcon icon={isActive ? faMinus : faPlus} />
        </button>
        <h4>Creators</h4>
      </button>
      <div className={`panel ${theme}`} style={{ maxHeight: isActive ? "400px" : "0" }}>
        {children}
      </div>
    </div>
  );
};

export default Accordion;
